import { atom } from "recoil"

export const searchFlgState = atom({
  key: "atoms/matching/search/searchFlgState",
  default: false,
})
